"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_1 = require("../../graphql");
const react_hooks_1 = require("@apollo/react-hooks");
exports.useEspGetListSubscribers = ({ integration, emailList, count, offset, status, }) => {
    var _a, _b, _c;
    const [mutate, mutationResult] = react_hooks_1.useMutation(graphql_1.espGetListSubscribers, {
        variables: {
            espId: (_a = integration) === null || _a === void 0 ? void 0 : _a.id,
            listId: (_b = emailList) === null || _b === void 0 ? void 0 : _b.id,
            options: {
                mailchimp: {
                    count,
                    offset,
                    status: (_c = status) === null || _c === void 0 ? void 0 : _c.value,
                },
            },
        },
    });
    return { mutate, mutationResult };
};
//# sourceMappingURL=useEspGetListSubscribers.js.map